<lacerta-full-width-image [image]="backgroundImage" [extraStylename]="'has-background-primary'" [backgroundSize]="'auto'">
  <div fxLayout="row" fxLayoutAlign="start center" fxFill>
    <div class="container">
      <ng-content></ng-content>
    </div>
  </div>
</lacerta-full-width-image>
